module.exports = __webpack_public_path__ + "static/media/politicEN.ba103b51.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/politicEN.pdf
// module id = 532
// module chunks = 0